<template>
	<div>
		<p v-if="$tera.project.measurementOfEffectToolUsed.length>0">
			{{
				selectRandom([
					""
						.concat(joinArrayWithAnd(formatSelectMulti($tera.project.measurementOfEffectToolUsed)))
						.concat(" was used to calculate the treatment effect."),
					"Overall intervention effect was calculated using "
						.concat(joinArrayWithAnd(formatSelectMulti($tera.project.measurementOfEffectToolUsed)))
						.concat("."),
					"Treatment/intervention effect was measured by "
						.concat(joinArrayWithAnd(formatSelectMulti($tera.project.measurementOfEffectToolUsed)))
						.concat("."),
					"Treatment/intervention effect was measured in "
						.concat(joinArrayWithAnd(formatSelectMulti($tera.project.measurementOfEffectToolUsed)))
						.concat(".")
				])
			}}
		</p>
		<p>
			{{
				selectRandom([
					"We used "
						.concat(
							$tera.project.dichotomousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.dichotomousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat(" for dichotomous outcomes."),
					"For dichotomous outcomes, treatment/intervention effect was calculated using "
						.concat(
							$tera.project.dichotomousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.dichotomousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat("."),
					"Effect of the intervention on dichotomous outcomes was expressed as "
						.concat(
							$tera.project.dichotomousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.dichotomousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat(".")
				])
			}}
		</p>
		<p>
			{{
				selectRandom([
					"We used "
						.concat(
							$tera.project.continuousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.continuousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat(" for continuous outcomes."),
					"For continuous outcomes, treatment/intervention effect was calculated using "
						.concat(
							$tera.project.continuousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.continuousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat("."),
					"Effect of the intervention on continuous outcomes was expressed as "
						.concat(
							$tera.project.continuousOutcomes
								? joinArrayWithAnd(
										formatSelectMulti($tera.project.continuousOutcomes)
								  ).toLowerCase()
								: "BLANK"
						)
						.concat(".")
				])
			}}
		</p>
		<p>
			We used
			{{
				$tera.project.otherOutcomes
					? joinArrayWithAnd(
							formatSelectMulti($tera.project.otherOutcomes)
					  ).toLowerCase()
					: "BLANK"
			}}
			to calculate treatement effect for other outcomes
		</p>
		<p>
			{{
				selectRandom([
					"We undertook meta-analyses when "
						.concat(
							$tera.project.metaAnalysisThreshold
								? $tera.project.metaAnalysisThreshold
								: "BLANK"
						)
						.concat(
							" studies or comparisons reported the same outcome. We used a "
						)
						.concat(
							$tera.project.metaAnalysisModelUsed
								? $tera.project.metaAnalysisModelUsed.toLowerCase()
								: "BLANK"
						)
						.concat(" model."),
					"We planned to do meta-analysis using a "
						.concat(
							$tera.project.metaAnalysisModelUsed
								? $tera.project.metaAnalysisModelUsed.toLowerCase()
								: "BLANK"
						)
						.concat(" model if there were ")
						.concat(
							$tera.project.metaAnalysisThreshold
								? $tera.project.metaAnalysisThreshold
								: "BLANK"
						)
						.concat(" or more studies with the same outcome.")
				])
			}}
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputMeasurementOfEffect",
	mixins: [OutputMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
